/** @jsx jsx */

import { jsx, render, Field, Variable, Mutation, SelectionSet, IdScalar } from "graphql-jsx";
import { clients } from "utils/clients";

type Option = Readonly<{
  id: string;
}>;

export const DeleteCommodity = async (option: Option) => {
  const $id = <Variable name="id" scalar={<IdScalar />} value={option.id} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_COMMODITY">
      <SelectionSet
        name="deleteCommodity"
        argument={{
          where: { commodity_id: $id }
        }}
      >
        <Field name="commodity_id" alias="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteCommodity: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.goods.request<Data>(query, variables);
};
